import React from 'react';
import FriendRow from 'app/components/friends/FriendRow';
import { connect } from 'react-redux';
import { viewFriend } from 'app/actions/friendsActions';
import { createFriendRequests } from 'app/actions/friendRequestActions';
import { addToGroup, removeFromGroup } from 'app/actions/groupActions';

function mapStateToProps(state: GlobalState, props: Props) {
  return {
    isSaving: state.friendGroups.savingGroups.has(props.group.id),
    isSavingFriendRequest: state.friendRequests.isSavingFriendRequest,
    isDeletingFriendRequest: state.friendRequests.isDeletingFriendRequest,
    isCreatingFriendRequest: state.friendRequests.isCreatingFriendRequests.length > 0,
  };
}
const actions = {
  onCreateFriendRequest: createFriendRequests,
  onViewFriend: viewFriend,
  onAddToGroup: addToGroup,
  onRemoveFriend: removeFromGroup,
};

export default connect(mapStateToProps, actions)(FriendRow);
